import React, { useEffect } from 'react'
import ManageContent from '../../components/ManageContent/ManageContent'
import { useDispatch, useSelector } from 'react-redux'
import { fetchReports } from '../../Reducers/actions/creationsActions'
import { fetchNewsReports } from '../../Reducers/actions/newsActions'
import Icon from '../../components/Icon/Icon'
import "./Admin.scss"

const Content = () => {
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(fetchReports())
        dispatch(fetchNewsReports())
    }, [dispatch])

    return (
        <div className='container-main'>
            <div className="content-header">
                <div className="header-left">
                    <Icon alias="news" width={24} height={24} color="#1a1a1a" />
                    <h2>Manage Creations</h2>
                </div>
                <p className="header-subtitle">Review and manage reported creations</p>
            </div>
            <ManageContent />
        </div>
    )
}

export default Content